(ns frontend.ui.component.lp-portal.report.tearsheet.return-development.view
  (:require
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.one-column-table.view :refer [one-column-table]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.style :as style]
   [herb.core :refer [<id]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn return-development-card
  [{:keys [tvpi return-development]}
   {:keys [edit-mode? save-text] :as props}]
  [card
   {:title "Return development"}
   [:div
    [chart (:figures tvpi)]
    (text-content/optional-footnote tvpi props)
    [:div {:id (<id style/table)}
     [one-column-table {:dom-key "figures"}
      (:figures return-development)]
     (text-content/optional-footnote return-development props)]]])
